<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Table of Reports-->
<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="loading == true || processing == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="loading == true || processing == true" class="btn btn-primary" style="margin-left: 5px" (click)="onImport()">Import</button>
		<button [disabled]="loading == true || processing == true" class="btn btn-primary" style="margin-left: 5px" (click)="onExport()">Export</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstReport"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedReport"
		dataKey="ReportID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--ReportID-->
				<th>
					<p-columnFilter type="text" field="ReportID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ReportDisplayName-->
				<th>
					<p-columnFilter type="text" field="ReportDisplayName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ReportFileName-->
				<th>
					<p-columnFilter type="text" field="ReportFileName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ReportGroupDesc-->
				<th>
					<p-columnFilter field="ReportGroupDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterReportGroupDesc
								[ngModel]="value"
								[options]="lstReportGroupDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ReportDT-->
				<th>
					<!-- <p-columnFilter type="text" field="ReportDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--ParmString-->
				<th>
					<p-columnFilter type="text" field="ParmString" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--DisplayInReports-->
				<th>
					<p-columnFilter field="DisplayInReports" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDisplayInReports
								[ngModel]="value"
								[options]="lstDisplayInReports"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="ReportID">Report ID<p-sortIcon field="ReportID"></p-sortIcon></th>
				<th pSortableColumn="ReportDisplayName">Display Name<p-sortIcon field="ReportDisplayName"></p-sortIcon></th>
				<th pSortableColumn="ReportFileName">File Name<p-sortIcon field="ReportFileName"></p-sortIcon></th>
				<th pSortableColumn="ReportGroupDesc">Group<p-sortIcon field="ReportGroupDesc"></p-sortIcon></th>
				<th pSortableColumn="ReportDT">Last Update<p-sortIcon field="ReportDT"></p-sortIcon></th>
				<th pSortableColumn="ParmString">Parameters<p-sortIcon field="ParmString"></p-sortIcon></th>
				<th pSortableColumn="DisplayInReports">Display In Reports Section<p-sortIcon field="DisplayInReports"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Report>
			<tr [pSelectableRow]="Report" (dblclick)="onRowDblClick(Report)">
				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Report[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
